/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAUpdateMyLivePlayersInput = {|
  eventId?: ?string,
  playerIds?: ?$ReadOnlyArray<?string>,
  lineupSetId?: ?string,
  clientMutationId?: ?string,
|};
export type LiveTournamentToolPageUpdateMyPlayersMutationVariables = {|
  input: PGAUpdateMyLivePlayersInput
|};
export type LiveTournamentToolPageUpdateMyPlayersMutationResponse = {|
  +pgaUpdateMyLivePlayers: ?{|
    +success: ?boolean
  |}
|};
export type LiveTournamentToolPageUpdateMyPlayersMutation = {|
  variables: LiveTournamentToolPageUpdateMyPlayersMutationVariables,
  response: LiveTournamentToolPageUpdateMyPlayersMutationResponse,
|};
*/


/*
mutation LiveTournamentToolPageUpdateMyPlayersMutation(
  $input: PGAUpdateMyLivePlayersInput!
) {
  pgaUpdateMyLivePlayers(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGAUpdateMyLivePlayersPayload",
    "kind": "LinkedField",
    "name": "pgaUpdateMyLivePlayers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveTournamentToolPageUpdateMyPlayersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveTournamentToolPageUpdateMyPlayersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3d60fce93bbd3398aefebf97d33018e",
    "id": null,
    "metadata": {},
    "name": "LiveTournamentToolPageUpdateMyPlayersMutation",
    "operationKind": "mutation",
    "text": "mutation LiveTournamentToolPageUpdateMyPlayersMutation(\n  $input: PGAUpdateMyLivePlayersInput!\n) {\n  pgaUpdateMyLivePlayers(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '85860b1ce6d6e3c949c247df8d476114';

module.exports = node;
